export default "__VITE_ASSET__6tbz0rDu__"